export default __webpack_public_path__ + "static/VisibleMobile-a7d2a998c9285d8bd6df0f9abf598d8c.svg";